import React from 'react'
import Button from '@mui/material/Button'
import { Link } from 'gatsby'

const ButtonLink = React.forwardRef((props, ref) => <Button component={ Link } ref={ ref } { ...props } />)

export default ButtonLink